import React, { useContext } from "react";
import { surveyService } from "../../services/survey.service"
import { Form, Input, Button, Layout, Row, Col,InputNumber } from 'antd';
import { authenticationService } from "../../services";
import { GlobalContext } from '../../contexts/GlobalContext';
import { useHistory } from "react-router-dom";
import './UpdatePassword.css'
const UpdatePassword = (props) => {
    const { errorHandler, successHandler } = useContext(GlobalContext);
    const history = useHistory()
    const [dataSource, setDataSource] = React.useState([])
    let [currentUserInformation,setCurrentUserInformation]=React.useState([])

  const getData = async () =>{
    let userInformation= await authenticationService.getUser()
    setCurrentUserInformation(userInformation)
   
}

React.useEffect(() => {
  const fetchData = async () => {
     await Promise.all([getData()]);
  }  
  fetchData();
},[])

const onFinish = async (credentials) => {

    let details = currentUserInformation.details
    details['firstLogin']=false
    if (credentials.password !== credentials.confirmPassword) {
      errorHandler("Lozinke se ne podudaraju")
    }
    else {
      
        const trimmedPassword=credentials.password.trim()
        let updateCredentials={id:currentUserInformation?.id,changedPassword:trimmedPassword,details:details}
        const userUpdatePassword = await authenticationService.userUpdatePassword(updateCredentials);
        console.debug("Got response update password:", userUpdatePassword)


        if (userUpdatePassword) {
          successHandler("Uspješno ste promjenili lozinku!")
          await authenticationService.logout()
          history.push('/app/login');
        }
        else {
          errorHandler("Neuspješna promjena lozinke! Molimo pokušajte ponovno kasnije.")
        }
      
    }
  };

 


    return (
    props.visible&&
    <div className="password-update__mask">
    <div className="password-update-modal">
      <Layout>
          <div className="white-box-update-password">
            <h1 className='password-update__title'>Postupak izmjene lozinke</h1>
            <p className='password-update__text'>U svrhu podizanja razine sigurnosti i učinkovitosti korištenja CikloParking programskih rješenja, neophodno je izmijeniti prethodno dostavljenu pristupnu lozinku. Nakon uspješno provedene izmjene pristupne lozinke, sustav će Vas automatski odjaviti nakon čega se u sustav prijavljujete isključivo s Vašom novopostavljenom lozinkom.</p>
            <p className='password-update__text'>CikloParking podrška: cikloparking@academica.hr</p>
            <Form
              name="password-update"
              className="password-update__form"
              onFinish={onFinish}
            >             

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Molimo unesite lozinku!',
                  },
                  { min: 6, message: 'Lozinka mora imati minimalno 6 znamenaka.' }
                ]}
              >
                <Input.Password placeholder="Nova lozinka" />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: 'Lozinke se ne podudaraju!',
                  },
                ]}
              >
                <Input.Password placeholder="Potvrda nove lozinke" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="register-form-button">
                  Promjeni lozinku
                </Button>
              </Form.Item>
            </Form>
          </div>
        
      </Layout>

    </div>
    </div>||<></>

    )
}

export default UpdatePassword;